import { pushDataLayerEvent } from '@alwindows/shared'

/**
 * GTM events for the screens flow — names + payload shapes are byte-identical
 * to the legacy app (al_screens/src/utils/DataLayerEvents.js +
 * constants/GAEventConstants.js) so the existing GTM container's triggers
 * keep firing without any container changes.
 */

/** Route change. Legacy fired `screens_pageview` on every page mount. */
export function trackPageView(pagepath: string): void {
  pushDataLayerEvent('screens_pageview', { pagepath })
}

/** Customer renamed an opening (legacy RoomName edit). */
export function trackEditWindow(windowName: string): void {
  pushDataLayerEvent('edit_window_name', { windowName })
}

/** Address resolved + selected from the autocomplete. */
export function trackAddressSelection(): void {
  pushDataLayerEvent('address_selection')
}

/** Address lookup returned nothing usable (no record / no orders). */
export function trackAddressNotFound(): void {
  pushDataLayerEvent('address_not_found')
}

/** Help / enquiry form submitted from the address flow. */
export function trackAddressEnquiry(): void {
  pushDataLayerEvent('address_enquiry')
}

/** Quote saved to SAP (legacy `save_order` with the RefNo). */
export function trackSaveOrder(referenceNumber: string): void {
  pushDataLayerEvent('save_order', { referenceNumber })
}
